export default {
  props: {
    group: {
      default: 'application'
    }
  },
  computed: {
    inputError () {
      return this.getError(this.errors?.[this.group], this.inputName)
    },

    hasInputErrors () {
      return this.hasError(this.errors?.[this.group], this.inputName)
    }
  }
}
